/**
 * Split tests to use in the app
 * Can be passed as a string (name) or an object with configuration
 * See defaults in split-test duck for default variants and other available options
 * @type {String|Array.Object}
 */

module.exports = [
  // 'HomePageLimitedTimeDeals', // Test 459
  'ProductPageBuyWithDLC', // Test 482
  'MoreVisualBrowseBannersDesktop', // Test 492
  'BundleTieredProductsReverseOrdering', // Test 494
  'MysteryBestValueLabel', // Test 495
  'MobileFeaturedDealsCarouselSlider', // Test 497
];
